import React, { useMemo, useState, useEffect, useRef } from 'react'
import {GETOWNERCODE } from '../../../../Utils/conts';
import TableGrid from "../../../../Components/common/TableGrid";
import TableFilters from '../../../../Components/common/TableGrid/TableFilters';
import { useDispatch, useSelector } from 'react-redux';
import { useGetInboundShipmentListQuery } from '../../../../redux/services/SPL';
import { getTodayDateTime, CallApi, CommonModal, getTodayDate } from '../../../../Components/common/CommonFunctions';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faSave } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as Editicon } from "../../../../assets/images/icon_svg/pen_w_line.svg";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { onTabChange } from '../../../../redux/features/table/tableSlice';

const Shipments = () => {
    const { pageDetails, filters, sortby } = useSelector((state) => state.table);
    const dispatch = useDispatch()
     const isMounted = useRef(false);
    const [warehouseModal, setWarehouseModal] = useState(false);
    const [warehouseModalData, setWarehouseModalData] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState('');
    const [warehouseOptions, setWarehouseOptions] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);

    const buildFilterParams = (filtersObj) => {
        const params = {};
        Object.entries(filtersObj).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) return;
            if (Array.isArray(value)) {
                params[key] = JSON.stringify(value);
            } else {
                params[key] = value;
            }
        });
        if (Object.keys(params).length > 0) {
            params.is_filter = true;
        }
        return params;
    };

    const queryParams = useMemo(() => {
        const filterParams = buildFilterParams(filters);
        const params = {
            ...filterParams,
            pagenum: pageDetails.pagenum,
            pagesize: pageDetails.pagesize,
        };
        if (sortby?.sortdatafield) {
            params.sortdatafield = sortby.sortdatafield;
            params.sortorder = sortby.sortorder;
        }
        // if (tab?.value && tab.value !== "all" && tab.key) {
        //     params[tab.key] = tab.value;
        // }
        return params;
    }, [filters, pageDetails, sortby]);

    const { data: myData, isFetching, refetch } = useGetInboundShipmentListQuery(queryParams, {
        skip: pageDetails.pagesize === 0,
        refetchOnMountOrArgChange: true,
    });

    const fetchWarehouse = async () => {
      CallApi({
          endPoint: "warehouse/list",
          method: "post",
          payload: {
            org_station_id: JSON.parse(
              localStorage.getItem("Handler_stn") || "{}"
            ).org_station_id,
            type: "All"
          },
          onSuccess: (res) => {
              const innerData = res.data.response_data;
              const transformedData = innerData ? innerData.map(item => ({
                  value: item.id,
                  label: item.name
              })) : [];
              setWarehouseOptions(transformedData);
          },
          onError: (msg) => console.error(msg)
      });
    };

        const fetchOwnerCode = async () => {
            CallApi({
                endPoint: GETOWNERCODE,
                method: "post",
                onSuccess: (res) => {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                },
                onError: (msg) => console.error(msg)
            });
        };

    useEffect(() => {
        dispatch(onTabChange({ key: 'tab', value: "A" }));
        if (isMounted.current) return;
        fetchWarehouse();
        fetchOwnerCode();
        isMounted.current = true;
    }, [])

    const openWarehouseModal = (row) => {
        setWarehouseModalData(row);
        setSelectedWarehouse(row.warehouse?.id || '');
        setWarehouseModal(true);
    };

    const closeWarehouseModal = () => {
        setWarehouseModal(false);
        setWarehouseModalData(null);
        setSelectedWarehouse('');
    };

    const handleSetWarehouse = () => {
        if (!selectedWarehouse) {
            toast.error("Please select a warehouse");
            return;
        }
        CallApi({
            endPoint: `inbound-flights/shipment-set-warehouse`,
            method: 'patch',
            payload: {
                shipment_id: warehouseModalData.id,
                warehouse_id: selectedWarehouse
            },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg || "Warehouse assigned successfully");
                    closeWarehouseModal();
                    refetch();
                } else {
                    toast.error(res.data.response_msg || "Something went wrong");
                }
            },
            onError: (msg) => toast.error(typeof msg === 'string' ? msg : "Something went wrong")
        });
    };

    const columns = [
        {
            label: "AWB No.", field: "awb_no", enableSearch: false, cls: "tw-6",
            renderCell: (row) => row?.awb_no
        },
        {
            label: "Warehouse", field: "warehouse", enableSearch: false, cls: "tw-6",
            renderCell: (row) => (
                <div>
                    {row.warehouse ? (
                        <>
                            {row.warehouse?.name || row.warehouse}
                            <Editicon
                                onClick={(e) => {
                                    e.stopPropagation();
                                    openWarehouseModal(row);
                                }}
                                style={{ cursor: "pointer", marginLeft: "5px" }}
                            />
                        </>
                    ) : (
                        <button className="edit_btn" onClick={(e) => {
                            e.stopPropagation();
                            openWarehouseModal(row);
                        }}>
                            Set Warehouse
                        </button>
                    )}
                </div>
            )
        },
        {
            label: "Flight No.", field: "flight_no", enableSearch: false, cls: "tw-6",
            renderCell: (row) => row?.rfs_monitor_handler_inbound_flight?.flight_no
        },
        {
            label: "Flight Date", field: "flight_date", enableSearch: false, cls: "tw-6",
            renderCell: (row) => row?.rfs_monitor_handler_inbound_flight?.flight_date
        },
        {
            label: "Origin", field: "origin", enableSearch: false, cls: "tw-6",
            renderCell: (row) => row?.fsu_message_clean?.origin_awb
        },
        {
            label: "Destination", field: "destination", enableSearch: false, cls: "tw-6",
            renderCell: (row) => row?.fsu_message_clean?.destination_awb
        },
        {
            label: "Created At", field: "created_at", enableSearch: false, cls: "tw-6",
            renderCell: (row) => getTodayDateTime(row?.created_at, "DMY")
        },
        {
            label: "Updated At", field: "updated_at", enableSearch: false,
            renderCell: (row) => getTodayDateTime(row?.updated_at, "DMY")
        },
    ];

    const filtersConfig = [
        { type: "input", field: "awb_no", placeholder: "AWB No." },
        { type: "input", field: "flight_no", placeholder: "Flight No." },
        { type: "multiselect", field: "flight_prefix", placeholder: "Flight Prefix", options: getOwnerCodes },
        { type: "multiselect", field: "warehouse_id", placeholder: "Warehouse", options: warehouseOptions },
    ];

    return (
        <div className="main-content">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <TableFilters filtersConfig={filtersConfig} />
            </div>
            <TableGrid
                columns={columns}
                rows={myData?.Rows}
                totalRecords={myData?.TotalRows || 0}
                onClickRow={(row) => console.log("Clicked Row:", row)}
                checkboxSelection={true}
                loading={isFetching}
                rowKey="id"
            />
            {console.log("warehouseModalDataaaaa",warehouseModalData)}

            <CommonModal
                show={warehouseModal}
                onHide={closeWarehouseModal}
                title="Set Warehouse"
                subTitle="Update warehouse for shipment"
                className="modal_bgw primary_modal"
                footer={
                    <div className="d-flex justify-content-between w-100 m-0">
                        <Button variant="secondary" onClick={closeWarehouseModal}>
                            <FontAwesomeIcon icon={faXmark} /> Cancel
                        </Button>
                        <Button variant="primary" onClick={handleSetWarehouse}>
                            <FontAwesomeIcon icon={faSave} /> Set Warehouse
                        </Button>
                    </div>
                }
            >
                <div className="resolve_dis primary_bg mb-2">
                    <h6>Shipment Details</h6>
                    <Row className="mb-2">
                        <Col sm={6}>
                            <div>
                                <label>AWB No.</label>
                                <p>{warehouseModalData?.awb_no || '-'}</p>
                            </div>
                        </Col>

                         <Col sm={6}>
                            <div>
                                <label>Total Pieces</label>
                                <p>{warehouseModalData?.fsu_message_clean?.total_pieces_awb || '-'}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <div>
                                <label>Flight No.</label>
                                <p>{warehouseModalData?.rfs_monitor_handler_inbound_flight?.flight_no || '-'}</p>
                            </div>
                        </Col>
                       
                        <Col sm={6}>
                            <div>
                                <label>Flight Date</label>
                                <p>{warehouseModalData?.rfs_monitor_handler_inbound_flight?.flight_date ? getTodayDate(warehouseModalData?.rfs_monitor_handler_inbound_flight?.flight_date,'DMY') : '-'}</p>
                            </div>
                        </Col>
                    </Row>
                </div>

                <Form.Group className="mb-2">
                    <Form.Label>Warehouse <span className="red">*</span></Form.Label>
                    <Select
                        options={warehouseOptions}
                        value={warehouseOptions.find(w => w.value === selectedWarehouse) || null}
                        onChange={(selected) => setSelectedWarehouse(selected?.value || '')}
                        placeholder="Warehouse"
                        isClearable
                        className="w-50"
                    />
                </Form.Group>
            </CommonModal>
        </div>
    );
};

export default Shipments;